import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Enconstruccion from "../Blog/Enconstruccion"


const Rutas = () => {


    return(
        <Router>
            <Fragment>
                    <Routes>
                        <Route path="/" element={<Enconstruccion />}/>
                    </Routes>
                      
            </Fragment>
        </Router>
    )
    


}

export default Rutas